

















































































import { Component, Vue } from 'vue-property-decorator'

@Component
export default class Profile extends Vue {
    mainTitle = 'Profile'
    loading = false
    confirmDialog = false
    formData: {[key: string]: unknown} = {}
    formValid = false
    formRules = {
        password: [
            (v: string) => !!v || 'Password is required',
            (v: string) => (v && v.length <= 191) || 'Password must be less than 191 characters'
        ]
    }

    get passwordRepeated () {
        return (this.formData.password === this.formData.passwordRepeated) || 'Passwords dont match'
    }

    async handleSave () {
        try {
            await (this.$refs.form as Vue & { validate: () => boolean }).validate()
            if (!this.formValid) return
            this.confirmDialog = true
        } catch (err) {
            console.log(err)
        }
    }

    async validateForm () {
        try {
            await (this.$refs.form as Vue & { validate: () => boolean }).validate()
            if (!this.formValid) return
            const { userId } = this.$store.state.AuthStore.auth.user
            const resp = await this.$store.dispatch('resetPassword', { userId, password: this.formData.password, confirmPassword: this.formData.passwordRepeated })
            if (resp?.status === 200) {
                this.$store.commit('reportSuccess', 'Done Successfully!')
                this.confirmDialog = false
            }
        } catch (err) {
            console.log(err)
        }
    }
}
